/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entryticketsfailed2Inputs */

const en_entryticketsfailed2 = /** @type {(inputs: Entryticketsfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The event is saved, but not every ticket type. Add them on the event page.`)
};

const de_entryticketsfailed2 = /** @type {(inputs: Entryticketsfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Event ist gespeichert, aber nicht alle Ticketarten. Leg sie auf der Eventseite an.`)
};

/**
* | output |
* | --- |
* | "The event is saved, but not every ticket type. Add them on the event page." |
*
* @param {Entryticketsfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entryticketsfailed2 = /** @type {((inputs?: Entryticketsfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entryticketsfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entryticketsfailed2(inputs)
	return de_entryticketsfailed2(inputs)
});
export { entryticketsfailed2 as "entryTicketsFailed" }